module.exports = __webpack_public_path__ + "static/media/florida.934c4695.jpg";